module.exports = "img/slide2.8b0e3d.jpeg";